export const optionMarkupType = [
    { label: "FLAT", value: "FLAT" },
    { label: "Percentage", value: "PERCENTAGE" },
];